export default class DownloadList {
  constructor( node ) {
    this.node = node;
    this.initClickEventHandler();
  }
  initClickEventHandler() {
    if ( this.node.classList.contains( 'downloadlist--accordion' )) {
      this.node.addEventListener( 'click', () => {

        if ( window.innerWidth < 1024 ) {
          this.node.classList.toggle( 'downloadlist--open' );

          if ( this.node.classList.contains( 'downloadlist--open' )) {
            this.node.children[ 0 ].children[ 1 ].classList.remove( 'collapsed' );
          } else {
            this.node.children[ 0 ].children[ 1 ].classList.add( 'collapsed' );
          }
        }
      });
    }
  }
}
